import {
  faFacebook,
  faInstagram,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import footerCss from "./Footer.module.css";
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <>
      <Container
        fluid={true}
        className={`${footerCss.Container} pt-3 pb-3 ${footerCss.mobile}`}
      >
        <Row className="mt-5 pb-3">
          <Col lg={3} md={6} sm={12}>
            <h2 className={`${footerCss.title} `}>Follow us</h2>
            <div className={`${footerCss.social}`}>
              <a href="">
                <FontAwesomeIcon icon={faFacebook} size="2x" />
              </a>
              <a href="">
                <FontAwesomeIcon icon={faYoutube} size="2x" />
              </a>
              <a href="">
                <FontAwesomeIcon icon={faInstagram} size="2x" />
              </a>
              <a href="">
                <FontAwesomeIcon icon={faTwitter} size="2x" />
              </a>
            </div>
          </Col>
          <Col lg={3} md={6} sm={12} className={footerCss.footerRes}>
            <h2
              className={`${footerCss.title} ms-1 ${footerCss.descriptionRes}`}
            >
              Address
            </h2>
            <div className={`${footerCss.description} `}>
              <div className={`${footerCss.description} ms-2`}>
                Road 10 Uttara Dhaka
              </div>
              <div className={`d-flex align-items-center ${footerCss.mobDes}`}>
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="text-white m-2"
                ></FontAwesomeIcon>{" "}
                <span>Email : support@gmail.com</span>
              </div>
              <div className={`d-flex align-items-center ${footerCss.mobDes}`}>
                <FontAwesomeIcon
                  icon={faPhone}
                  className="text-white m-2"
                ></FontAwesomeIcon>
                <span> Phone : +0192894004</span>
              </div>
            </div>
          </Col>
          <Col lg={3} md={6} sm={12} className={footerCss.footerRes}>
            <h2 className={`${footerCss.title} `}> Information</h2>
            <Link to="/about" className={`${footerCss.footerLink}`}>
              About Me
            </Link>
            <Link to="/about" className={`${footerCss.footerLink}`}>
              Company Profile
            </Link>
            <Link to="/contact" className={`${footerCss.footerLink}`}>
              Contact Us
            </Link>
          </Col>
          <Col lg={3} md={6} sm={12} className={footerCss.footerRes}>
            <h2 className={`${footerCss.title} `}>Policy</h2>
            <Link to="/refund" href="" className={`${footerCss.footerLink}`}>
              Refund Policy
            </Link>
            <Link to="/terms" className={`${footerCss.footerLink}`}>
              Terms And Conditions
            </Link>
            <Link to="/privacy" className={`${footerCss.footerLink}`}>
              Privacy Policy
            </Link>
          </Col>
        </Row>
      </Container>
      <Container fluid={true} className={`${footerCss.copyright}`}>
        <p className="mt-3">
          &copy;Copyright 2022 by E-learning. All rights reserved.
        </p>
      </Container>
    </>
  );
}
